import gql from 'graphql-tag'

export const GET_ORDER_ITEM = gql`
  query GetOrderItem($orderItemId: ID!) {
    getOrderItem(orderItemId: $orderItemId)
  }
`

export const GET_ORDER_ITEMS = gql`
  query GetOrderItems($eventId: ID!, $pagination: Pagination, $isGratis: Boolean) {
    getOrderItems(eventId: $eventId, pagination: $pagination, isGratis: $isGratis) {
      items {
        id
        eventId
        name
        type
        price
        currency
        description
        organizationItemCategoryId
        createdAt
        updatedAt
        quantity
        initialQuantity
        itemMeta
        from
        to
        prepaidCoupon
        validityType
        hasDateValidationRange
        entryFrom
        entryTo
        event {
          from
          to
          soldOut
          extraModules {
            floorPlan
          }
        }
        organizationItemCategory {
          id
          name
          color
        }
        ticketSellerOrganizations {
          id
          name
        }
      }
      totalCount
      hasParterTickets
    }
  }
`

export const GET_ORDER_ITEM_TICKET_OPTIONS = gql`
  query GetOrderItemTicketOptions($eventId: ID!, $pagination: Pagination, $isGratis: Boolean) {
    getOrderItems(eventId: $eventId, pagination: $pagination, isGratis: $isGratis) {
      items {
        id
        name
        type
        price
        currency
        itemMeta
      }
    }
  }
`

export const UPDATE_ORDER_ITEM_SECTION_SEATS = gql`
  mutation updateOrderItemSectionSeats(
    $orderItemId: ID!
    $seats: [String!]!
    $venueId: ID!
    $organizationSlug: String!
    $eventId: ID!
  ) {
    updateOrderItemSectionSeats(
      orderItemId: $orderItemId
      seats: $seats
      venueId: $venueId
      organizationSlug: $organizationSlug
      eventId: $eventId
    ) {
      id
      eventId
      name
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
      sectionSeats
    }
  }
`
export const DISCONNECT_ORDER_ITEM_SECTION_SEATS = gql`
  mutation DisconnectOrderItemSectionSeats(
    $seats: [String!]!
    $venueId: ID!
    $organizationSlug: String!
    $eventId: ID!
  ) {
    disconnectOrderItemSectionSeats(
      seats: $seats
      venueId: $venueId
      organizationSlug: $organizationSlug
      eventId: $eventId
    ) {
      id
      eventId
      name
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
      sectionSeats
    }
  }
`

export const CREATE_ORDER_ITEM = gql`
  mutation CreateOrderItem($eventId: ID!, $input: OrderItemInput!) {
    createOrderItem(eventId: $eventId, input: $input) {
      id
      eventId
      name
      type
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
    }
  }
`

export const CREATE_GRATIS_ORDER_ITEM = gql`
  mutation CreateGratisOrderItem(
    $eventId: ID!
    $input: OrderItemInput!
    $seats: [String!]
    $floorPlanSelections: [GratisFloorPlanSelectionInput!]
    $requestId: String
  ) {
    createGratisOrderItem(eventId: $eventId, input: $input, seats: $seats, floorPlanSelections: $floorPlanSelections, requestId: $requestId)
  }
`

export const UPDATE_GRATIS_ORDER_ITEM = gql`
  mutation UpdateGratisOrderItem($orderItemId: ID!, $eventId: ID!, $input: OrderItemInput!) {
    updateGratisOrderItem(orderItemId: $orderItemId, eventId: $eventId, input: $input) {
      id
      hasDateValidationRange
      entryFrom
      entryTo
      validityType
    }
  }
`

export const UPDATE_ORDER_ITEM = gql`
  mutation UpdateOrderItem(
    $orderItemId: ID!
    $input: OrderItemInput!
    $organizationId: ID
    $organizationSlug: String
  ) {
    updateOrderItem(
      orderItemId: $orderItemId
      input: $input
      organizationId: $organizationId
      organizationSlug: $organizationSlug
    ) {
      id
      eventId
      name
      type
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      initialQuantity
      itemMeta
      from
      to
      showIfSold
    }
  }
`
export const UPDATE_SALES_CHANNELS = gql`
  mutation UpdateSalesChannels($salesChannels: [ID!]!, $eventId: ID!) {
    updateSalesChannels(salesChannels: $salesChannels, eventId: $eventId)
  }
`

export const DELETE_ORDER_ITEM = gql`
  mutation DeleteOrderItem($orderItemId: ID!) {
    deleteOrderItem(orderItemId: $orderItemId)
  }
`

export const DELETE_ORDER_ITEMS = gql`
  mutation DeleteOrderItems($orderItemIds: [ID!]!) {
    deleteOrderItems(orderItemIds: $orderItemIds)
  }
`

export const GET_ONLINE_ORDER_ITEMS = gql`
  query getOnlineOrderItems($eventId: ID!, $accessCode: String) {
    getOnlineOrderItems(eventId: $eventId, accessCode: $accessCode) {
      id
      eventId
      name
      type
      orderItemTemplateId
      price
      currency
      description
      membership
      prepaidCoupon
      createdAt
      updatedAt
      quantity
      initialQuantity
      from
      to
      showIfSold
      itemMeta
      organizationItemCategory {
        id
        name
        priority
        description
        color
        displayIfSoldOut
      }
      bundleOffer {
        id
        availableQuantity
        quantityInterval
        freeQuantity
      }
    }
  }
`

export const CHANGE_TICKET_VALIDITY_DATES = gql`
  mutation ChangeTicketValidityDates(
    $organizationSlug: String!
    $orderItemId: ID!
    $validity: Boolean!
  ) {
    changeTicketValidityDates(
      organizationSlug: $organizationSlug
      orderItemId: $orderItemId
      validity: $validity
    )
  }
`

export const GET_ALL_ACTIVE_ORGANIZATION_TICKETS = gql`
  query GetAllActiveOrganizationTickets($organizationSlug: String!, $includeOrderItemId: ID) {
    getAllActiveOrganizationTickets(
      organizationSlug: $organizationSlug
      includeOrderItemId: $includeOrderItemId
    ) {
      id
      name
      bundleOfferId
      price
      event {
        id
        title
        from
        eventTemplateId
      }
    }
  }
`

export const CANCEL_GRATIS_ORDER_ITEM = gql`
  mutation CancelGratisOrderItem($eventId: ID!, $orderItemId: ID!) {
    cancelGratisOrderItem(eventId: $eventId, orderItemId: $orderItemId) {
      cancelledCount
      scannedCount
      remainingCount
      releasedLocationCount
      fullyCancelled
    }
  }
`
